<template>
	<div>
		<!-- 项目问题 -->
		<listheader @settable="setfntable" @uprenew="uprenew" @screen="fn_screen" ref="refader" title="项目问题"
			:localoperate="localviewOperate" :types="6" :vieid="18" @exportclick="exportclick" :filter_items="filterpuplist"
			:one_selectlist="Levellist" :two_selectlist="Statuslist" @importclick="importclick" @createclick="createclick">
		</listheader>
		<!-- 新建，编辑 -->
		<newbullet :title="billet_tit" :loading="!createPup" :isshow.sync="createPup" :classlist="classlist"
			:fieldlist="field_create" @saveer="fnCreateSave" @fnswitch="switchModule" :savenew="savenew"></newbullet>
		<!-- 列表 -->
		<div class="table_box style2" v-loading="table_loading" v-show="!table_loading">
			<!--  -->
			<!-- datapage   -->
			<tabcontainer :ischecks="false" :list.sync="datapage.list" :total.sync="datapage.total"
				:pagesize.sync="datapage.pagesize" :page.sync="datapage.page" :surplus="surplus" @returow="showDetails"
				@retucheck="(e) => { check_list = e.val; }" @changesize="modify_pagesize" @changepage="switch_page">
				<!--  -->
				<template slot="body">
					<!--  -->
					<el-table-column align="center" type="selection" width="50"></el-table-column>
					<!--  -->
					<el-table-column show-overflow-tooltip :width="item.width" :prop="item.prop" :label="item.name"
						v-for="(item, index) in tableColumn">
					</el-table-column>
					<!--  -->
				</template>
				<!--  -->
				<!--  -->
				<template slot="tabtns">
					<el-button @click="custom_click(1)" class="color1" :disabled="check_list.length == 0">
						删除问题
					</el-button>

				</template>
				<!--  -->
			</tabcontainer>
			<!--  -->
		</div>
		<!-- 详情划窗 -->
		<detailspup ptitle="问题信息" ref="detailspup" :types="3" :dinfo="currentDetail_info" :isshow.sync="drawer_show"
			:loading="drawer_loading" :stablelist="comtomerModuleTable" :classlist="classlist" :fieldlist="field_details"
			@editdatas="fn_editdatas" @delesucc="fn_delesucc" :content_id="drawer_info.project_demand_id"
			:memberlist="memberlist" :statuslist="Statuslist" @update="fn_update"></detailspup>
		<!--  -->
	</div>
</template>

<script>
var that;

import {
	deepEqual,
	deepStrs,
	fn_retjson,
	retJSONArr,
	Basics_field,
	contrastDaily,
	headleTime,
	fn_findeditid,
	fn_Judgmentbtn,
} from "network/defaults";

import {


	timestampToTime,
	fnCustomPage,
	clickgate,
	getFollowUpList,
	getMumberUser,

	exportExcel,
} from "network/kh_public";
import {
	get_membelist,
	addCustomerFollow,
	ToggleTime,
	handErrJson,
	fn_newfield,
	Basics_kehu,

	getCurrentWeek,
	lx_typelist,
} from "network/hk_operset";
import {
	getfollow_up_list,
	get_module_comtomer,
	get_customer_form_id,
} from "network/hk_customer";

import {
	get_project_demand_code,
	get_project_damand_status,
	get_project_damand_level,
	add_project_damand,
	get_project_damand_list,
	del_project_damand,
	get_project_damand_details,
	update_project_damand,
} from "../js/project.js";


import newbullet from "../components/newpup/newbullet.vue"
import detailspup from "../components/newpup/detailspup.vue"
// import detailspup from "./components/detailspup.vue"

import listheader from "@/components/tabulation/listheader.vue";
import tabcontainer from "@/components/tabledata/tabcontainer.vue";
export default {
	components: {
		listheader,
		tabcontainer,

		newbullet,
		detailspup,
	},
	watch: {
		drawer_show() {
			if (!this.drawer_show) { // 详情划窗关闭
				this.clear_drawer()
			}
		},


	},
	created() {

		let { isDetail, project_demand_id } = this.$route.query;
		if (isDetail && project_demand_id) {
			this.pageloading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.currentpup_id = project_demand_id;
			this.fn_getDelait();
		}
		this.getMumberList()
		this.fn_getdamandLevel()
		this.fn_getdamandStatus()
		// this.fnget_ypelist()

		this.surplus = this.$store.state.surplus
	},
	methods: {

		fn_delesucc() {
			this.drawer_show = false
			this.fn_tabledata();
		},

		clear_drawer() {
			this.dailyRecord = [] // 编辑前的字段 ，用于判断是否修改过
			this.drawer_info = '' // 详情所有信息
			this.currentDetail_info = '' // 用于弹窗的字段
			this.editfieldlist = [] // 用于编辑的字段
			this.currentpup_id = '' // 当前详情id
			this.isTableShow = false
			this.comtomerModuleTable = []
			this.field_details = []
			this.savenew = true
			this.edit_show = false

			this.currentMod_id = ''
		},

		exportclick() {
			exportExcel("#exportTab", "项目问题");
		},
		importclick() {

		},

		// 级别 
		fn_getdamandLevel() {
			get_project_damand_level().then((res) => {
				if (this.$handlereq(res)) {
					let obj = res.result || []
					for (let item of obj) {
						item.id = item.level_id
					}
					this.Levellist = obj
				}
			})
		},

		//状态
		fn_getdamandStatus() {
			get_project_damand_status().then((res) => {
				if (this.$handlereq(res)) {
					let obj = res.result || []
					for (let item of obj) {
						item.id = item.status_id
					}
					this.Statuslist = obj
				}
			})
		},
		// 切换模板
		switchModule(e) {
			this.field_create = []
			this.field_initial = [];
			let formId = e;
			this.currentMod_id = formId;
			if (this.edit_show) {
				this.getmodulelist(this.c_projcet_div_id)
			} else {
				this.getmodulelist(this.c_projcet_div_id)

			}
		},
		// 保存数据处理
		fn_Savedatas() {
			let currobj = this.savelist;
			let fd = new FormData();
			fd.append('type', 3);
			for (let i = 0; i < this.Referencearr.length; i++) {
				let {
					name,
					key
				} = this.Referencearr[i]
				let res_ = this.findfont(name)
				fd.append(key, res_);
			}
			for (let i = 0; i < this.ReferenceTime.length; i++) {
				let {
					name,
					key
				} = this.ReferenceTime[i]
				let res_ = this.findfont(name)
				if (res_) {
					let len = (res_ + "").length;
					let time_Res = len > 10 ? ((res_ + '').slice(0, 10) * 1) : res_;
					fd.append(key, time_Res);
				}
			}
			// 
			let assistant = this.findfont("协同人");
			if (assistant.length) {
				// 	否	string	协同人id	逗号间隔 加 逗号
				fd.append("assistant_member_id", assistant.join(",") + ",");
			}
			// 
			let newArr = Basics_field(currobj);
			fd.append("project_demand_info", JSON.stringify(newArr));
			return fd;
		},
		findfont(field) {
			if (this.savelist.length) {
				let index = this.savelist.findIndex((v) => v.field_sign == field || v.field == field);
				if (index != -1) {
					return this.savelist[index].content;
				} else {
					return "";
				}
			}
		},
		// 新建,编辑保存
		fnCreateSave(e) {
			if (e && e.fieldlist) {
				let {
					flag,
					fieldlist
				} = e
				this.savelist = retJSONArr(fieldlist) || [];
				let resdata = this.fn_Savedatas()
				if (this.edit_show) { //编辑
					resdata.append('project_demand_id', this.currentpup_id);
					// 操作日志
					let oldDaily = this.dailyRecord;
					let edit_data = contrastDaily(oldDaily, this.savelist, 1);
					if (edit_data) {
						resdata.append('edit_data', edit_data);
					}
					update_project_damand(resdata).then((res) => {
						if (this.$handlereq(res)) {
							this.$alertMess("编辑成功", "success");
							this.field_create = [];
							this.drawer_show = false;
							this.createPup = false;
							this.fn_tabledata();
						}
					});
				} else { // 新建
					add_project_damand(resdata).then((res) => {
						if (this.$handlereq(res)) {
							this.$alertMess("添加成功", "success");
							this.field_create = [];
							if (flag) {
								this.createclick();
							} else {
								this.createPup = false;
								this.clear_drawer()
							}
							this.fn_tabledata();
						}
					});
				}
			}
		},

		// 编辑点击
		fn_editdatas() {
			this.edit_show = true
			this.savenew = false
			this.billet_tit = '编辑问题'
			if (this.field_create.length) {
				this.createPup = true
			} else {
				this.getmodulelist(this.c_projcet_div_id)
			}
		},
		// 新建点击
		createclick() {
			this.billet_tit = '新建问题'
			this.edit_show = false
			this.savenew = true
			this.field_create = []
			this.fn_getProject_Code()
		},
		// "问题编号"
		fn_getProject_Code() {
			get_project_demand_code().then((res) => {
				if (this.$handlereq(res)) {
					let resobj = res.result ? res.result.project_demand_code : '';
					this.projectCode = resobj
					this.getmodulelist(this.c_projcet_div_id)
				}
			})
		},
		// 获取所有字段模板 1级模板
		getmodulelist(projcet_div_id) {
			get_module_comtomer(projcet_div_id).then((res) => {
				if (this.$handlereq(res)) {
					let obj = res.result || []
					if (obj.length) {
						for (let item of obj) {
							item.id = item.form_id
						}
					};
					// 新建默认选择系统模板 使用 form_id 2级模板
					let form_id = obj[0].form_id || '';
					this.currentModulList = obj;
					// 2级模板id
					if (!this.currentMod_id) {
						this.currentMod_id = form_id;
					}
					else {
						let id_flag = obj.some(v => v.form_id == this.currentMod_id)
						if (!id_flag) {  // 未找到该模板
							this.currentMod_id = form_id;
						}
					}
					if (this.field_initial.length) {
						let obj = fn_retjson(this.field_initial)

						// 赋值改动字段
						this.handle_createdField(obj)
						// 获取表头展示
						if (this.isTableShow) {
							this.field_details = fn_retjson(obj)
							this.drawer_show = obj.length ? true : false;
							this.drawer_loading = !this.drawer_show;
						} else {
							// 创建弹窗 是否弹出
							this.createPup = obj.length ? true : false;
							this.clear_drawer()
						}
						this.field_create = obj
					} else {
						this.getmoduleField(projcet_div_id, this.currentMod_id)
					}

				}
			});
		},
		// 获取当前选用模板下的所有字段信息  获取2级模板
		getmoduleField(projcet_div_id, form_id) {
			get_customer_form_id(form_id, 1, projcet_div_id).then((res) => {
				if (this.$handlereq(res)) {
					let obj = res.result || [];
					// 未修改初始字段
					this.field_initial = fn_retjson(obj)
					// 赋值改动字段
					this.handle_createdField(obj)
					// 获取表头展示
					if (this.isTableShow) {
						this.field_details = fn_retjson(obj)
						this.drawer_show = obj.length ? true : false;
						this.drawer_loading = !this.drawer_show;
					} else {
						// 创建弹窗 是否弹出
						this.createPup = obj.length ? true : false;
						this.clear_drawer()
					}
					this.field_create = obj
				}
			})
		},

		// 处理新建字段  drawer_info project_demand_info
		handle_createdField(data) {
			for (let item of data) {
				fn_newfield(item, false)
				item.is_show = true // 字段显示
				item.disabled = false // 字段禁用
				// required: 1 必填
				if (item.field_type == 18) { // 富文本
					item.field_type = 19
				}
				// 详情信息
				if (this.editfieldlist.length) {
					let curid = item.field_id || item.id;
					let res1 = fn_findeditid(curid, this.editfieldlist, this.field_initial)
					if (res1) {
						item.content = res1.content
						item.select_field = res1.select_field
					}
				}

				let field = item.field || item.field_sign;
				let datafield = ["问题开始日期", "计划完成日期"]
				let flagfiler = datafield.some((v) => v == field);
				if (flagfiler) {
					item.field_type = 3;
					if (item.content) {
						let len_ = (item.content + '').length
						item.content = len_ > 10 ? item.content : item.content * 1000;
					}
				}

				if (field == '问题编号') {
					if (this.drawer_info) {
						item.content = item.select_field = this.drawer_info.project_demand_code
					} else {
						item.content = item.select_field = this.projectCode
					}
				}
				else if (field == '问题名称') {
					if (this.drawer_info) {
						item.content = item.select_field = this.drawer_info.title
					}
				}
				else if (field == '问题内容') {
					if (this.drawer_info) {
						item.content = item.select_field = this.drawer_info.content
					}
				}
				else if (field == '问题开始日期') {
					if (this.drawer_info) {
						item.content = item.select_field = Date.parse(this.drawer_info.start_time)
					}
					else {
						item.content = Date.parse(new Date())
					}
				}
				else if (field == '计划完成日期') {
					if (this.drawer_info) {
						item.content = item.select_field = Date.parse(this.drawer_info.plan_completion_time)
					}

				}

				else if (field == '问题级别') {
					item.field_type = 5
					item.field_list = this.Levellist

					if (this.drawer_info) {
						item.content = this.drawer_info.level
						item.select_field = this.drawer_info.level_name
					}
					else {
						item.content = this.Levellist[0] ? this.Levellist[0].id : '';
					}

				} else if (field == '问题状态') {
					item.field_type = 5
					item.field_list = this.Statuslist

					if (this.drawer_info) {
						item.content = this.drawer_info.status
						item.select_field = this.drawer_info.status_name
					}
					else {
						item.content = this.Statuslist[0] ? this.Statuslist[0].id : '';
					}
				}
				else if (field == '问题类型') {
					item.field_type = 5
					item.field_list = this.typeslist
					item.singleval = {}

					if (this.drawer_info) {
						let type_id = this.drawer_info.project_demand_type
						item.content = type_id
						let index1 = this.typeslist.findIndex(v => v.id == type_id)
						if (index1 != -1) {
							item.select_field = this.typeslist[index1].name
						}
					}
					else {
						item.content = this.typeslist[0] ? this.typeslist[0].id : '';
					}
				}
				else if (field == '问题项目') {
					item.field_type = 11
					item.field_list = []
					item.trends = true
					if (this.drawer_info && this.drawer_info.project_result) {
						let c_obj = this.drawer_info.project_result || '';
						let c_id = c_obj.is_recycle == 1 ? c_obj.name : c_obj.project_id * 1;
						let c_name = c_obj ? c_obj.name : '';
						item.content = c_id
						item.select_field = c_name
						item.singleval = {
							id: c_id,
							name: c_name,
						}
					}
				}
				else if (field == "负责人") {
					item.character = true
					item.field_type = 5
					item.field_list = this.memberlist

					if (this.drawer_info) {
						item.content = this.drawer_info.member_id
						item.select_field = this.drawer_info.member_name
					} else {
						item.content = localStorage.member_id * 1;
					}

				} else if (field == "协同人") {
					item.character = true
					item.field_type = 6
					item.field_list = this.memberlist
					item.select_field = item.content = []

					if (this.drawer_info) {
						let assistant_arr1 = this.drawer_info.assistant_member_id ? this.drawer_info
							.assistant_member_id.split(',') : [];
						let assistant_arr2 = []
						for (let ass of assistant_arr1) {
							if (ass) {
								assistant_arr2.push(ass * 1)
							}
						}
						item.content = assistant_arr2
						if (this.memberlist.length && assistant_arr2.length) {
							let res_arr = []
							for (let val of assistant_arr1) {
								let arr1 = this.memberlist.filter(v => v.member_id == val)
								let name = arr1[0] ? arr1[0].name : '';
								if (name) {
									res_arr.push(name)
								}
							}
							item.select_field = res_arr.length ? res_arr.join('、') : '';

						} else {
							item.select_field = ''
						}
					}

				} else if (field == this.templaName) { // 模板
					item.field_type = 18
					item.field_list = this.currentModulList
					item.content = this.currentMod_id
					if (this.drawer_info) {
						let cindex = this.currentModulList.findIndex(v => v.id == this.currentMod_id)
						if (cindex != -1) {
							item.select_field = this.currentModulList[cindex].name
						}
					}
				}
				// 表头展示
				if (item.is_table == 1) {
					let ele = {
						character: item.character ? true : false,
						field: field,
						select_field: item.select_field,
						table_sort: item.table_sort,
					}
					this.comtomerModuleTable.push(ele)
				}

			}
			console.log(this.comtomerModuleTable, 'comtomerModuleTable')
			this.dailyRecord = JSON.parse(JSON.stringify(data))
		},
		//





		//获取成员列表
		getMumberList() {
			getMumberUser().then((res) => {
				if (res.code == 1000) {
					let obj = res.result || [];
					for (let item of obj) {
						item.id = item.member_id
					}
					this.memberlist = obj
					this.setfilterArea()
				}
			});
		},


		clearfilter() {
			this.search_member = []
			this.assistantMember = []
			this.search_time = ''
			this.search_edit_time = ''
		},
		// 筛选条件列表更新
		setfntable(e) {
			this.clearfilter()
			if (e && e.list) {
				let reslist = retJSONArr(e.list)
				this.setcustomfil(reslist)
				this.FilterList = reslist.length ? fn_retjson(reslist) : fn_retjson(this.defFilter); // 筛选条件列表
			}
			this.fn_tabledata();
		},
		setcustomfil(reslist) {
			for (let item of reslist) {
				let {
					lv1_selVal, lv2_selVal, lv3_selVal
				} = item

				if (lv1_selVal == 0) { } // 创建人
				if (lv1_selVal == 1) {  // 负责人
					this.search_member = lv3_selVal || []
				}
				if (lv1_selVal == 2) {  // 协同人
					this.assistantMember = lv3_selVal || []
				}
				if (lv1_selVal == 3) {  // 添加时间
					let restime = headleTime(lv3_selVal, lv2_selVal)
					this.search_time = restime
				}
				if (lv1_selVal == 4) {  // 更新时间
					let restime = headleTime(lv3_selVal, lv2_selVal)
					this.search_edit_time = restime
				}
			}
		},
		// 下拉筛选改变
		fn_screen(e) {
			if (e) {
				this.search_name = e.search_name || ''
				this.sort_type = e.sort_type || 1
				this.screVal1 = e.level || []
				this.screVal2 = e.status || []
				this.fn_tabledata();
			}
		},
		// 视图选择更新
		uprenew(e) {
			if (e && e.view_operate) { // 视图配置
				this.remoteviewOperate = retJSONArr(e.view_operate)
				this.clearSrceen()
				this.executeViewOperate();
			}
		},
		clearSrceen() {
			this.screVal1 = [];
			this.screVal2 = [];
			this.screVal3 = [];
			this.search_time = '';
			this.search_edit_time = '';
			this.search_name = "";
			this.search_member = [];
			this.assistantMember = [];
			this.sort_type = 1
		},
		// 执行视图配置   this.List  筛选条件
		executeViewOperate() {
			// 全部清空筛选
			if (this.remoteviewOperate.operate != 100) { // 系统视图
				if (this.$refs.refader) {
					this.$refs.refader.clearScreen()
				}
				this.class_type = this.remoteviewOperate.operate - 1;
				this.FilterList = fn_retjson(this.defFilter)
				this.fn_tabledata();
			} else { // 用户创建视图
				if (this.remoteviewOperate.class_type === undefined) {
					if (this.$refs.refader) {
						this.$refs.refader.clearScreen()
						this.FilterList = fn_retjson(this.defFilter)
					}
					this.class_type = 0;
					this.fn_tabledata();
				} else {
					let obj = this.remoteviewOperate
					this.class_type = fn_retjson(obj.class_type) // 资源类型
					this.screVal1 = fn_retjson(obj.level) // 级别
					this.screVal2 = fn_retjson(obj.status) // 状态

					this.search_name = fn_retjson(obj.search_name) // 搜索名称
					this.FilterList = fn_retjson(obj.List) // 筛选条件列表
					this.sort_type = fn_retjson(obj.sort_type) // 排序
					this.search_member = fn_retjson(obj.search_member) // 负责人
					if (obj.List) {
						this.setcustomfil(obj.List)
					}
					let flag_ = deepStrs(this.defFilter, this.FilterList)
					// 当前筛选列表不等于默认列表
					if (!flag_) {
						this.fn_tabledata();
					}

				}
			}
		},
		// 获取当前本地视图配置
		fn_localView() {
			this.localviewOperate = {
				operate: 100,
				class_type: this.class_type,
				level: this.screVal1,
				status: this.screVal2,
				search_name: this.search_name,
				List: this.FilterList,
				sort_type: this.sort_type,
				search_member: this.search_member,
			};
		},

		// 执行搜索
		fn_tabledata() {
			this.table_loading = true;
			this.fn_localView();

			this.JudgmentOpen();
			let data = {
				sort_type: this.sort_type, //  否	string	排序类型 1:最新释放2:最新创建3:最新访问4:最新跟进
				pagesize: this.datapage.pagesize, //  	是	int	每页数量
				page: this.datapage.page,
				type: 3,
			};
			data.class_type = this.class_type || 0;
			let search_val = (this.search_name + '').trim()
			if (search_val) {
				data.search_type = this.search_type; //  否	int	搜索类型 //1:名称2:手机号
				data.search_name = search_val;
			}
			if (this.screVal1.length) {
				data.level = this.screVal1.join(",")
			}
			if (this.screVal2.length) {
				data.status = this.screVal2.join(",")
			}
			if (this.search_time) {
				data.search_time = this.search_time
			}
			if (this.search_edit_time) {
				data.edit_time = this.search_edit_time
			}
			if (this.search_member.length) {
				data.member_id = this.search_member.join(",");
			}
			if (this.assistantMember.length) {
				data.assistant_member_id = this.assistantMember.join(",");
			}


			get_project_damand_list(data).then((res) => {
				if (this.$handlereq(res)) {
					let obj = res.result.data;
					this.handle_data(obj);
					this.datapage.total = res.result.total;
					this.table_loading = false;
				}
			});
		},

		// 处理数据
		handle_data(data) {
			if (data) {
				for (let item of data) {
					item.plan_completion_time = (item.plan_completion_time + '').slice(0, 10)
					item.start_time = (item.start_time + '').slice(0, 10)
				}
				this.datapage.list = data;
			}
		},
		//

		// 批量按钮点击  project_demand_id
		custom_click(index) {
			let list = this.check_list;
			if (list.length > 0) {
				let newArr = [];
				for (let item of list) {
					newArr.push(item.project_demand_id);
				}

				if (index == 1) {
					// 删除
					this.release_gh(newArr.join(","))
				}
			}
		},
		// 删除
		release_gh(project_demand_id) {
			this.$confirm("您确定要删除吗?")
				.then(() => {
					let data = {
						project_demand_id,
						type: 3,
					}
					del_project_damand(data).then((res) => {
						if (this.$handlereq(res)) {
							this.fn_tabledata();
							this.$alertMess("删除成功", "success");
						}
					});
				})
				.catch(() => { });
		},



		setsaveBtn(flag) {
			if (this.$refs.refader) {
				this.$refs.refader.setSaveBtn(flag)
			}
		},
		setnewBtn(flag) {
			if (this.$refs.refader) {
				this.$refs.refader.setNewBtn(flag)
			}
		},
		//判断视图按钮是否打开
		JudgmentOpen() {
			let findobj = {
				localviewOperate: this.localviewOperate,
				remoteviewOperate: this.remoteviewOperate,
				defFilter: this.defFilter,
				FilterList: this.FilterList,
				screVal1: this.screVal1,
				screVal2: this.screVal2,
				search_name: this.search_name,
				sort_type: this.sort_type,
				def_sort: 1,
			}
			let resobj = fn_Judgmentbtn(findobj)
			let { customflag, systemflag } = resobj
			if (customflag) { // 用户创建的视图
				this.setsaveBtn(customflag)
			}
			else {  // 系统视图
				this.setnewBtn(systemflag)
			}
		},
		// ---
		showDetails(e) {
			let {
				row
			} = e;
			if (row.project_demand_id) {
				// 当前点击的id
				this.currentpup_id = row.project_demand_id;
				this.fn_getDelait();

			}
		},
		// 划窗刷新
		fn_update() {
			this.field_details = []
			this.fn_getDelait();
		},
		// 获取详情  组件: detailspup
		fn_getDelait() {
			let data = {
				project_demand_id: this.currentpup_id,
				type: 3,
			}
			this.drawer_loading = true;
			get_project_damand_details(data).then((res) => {
				if (this.$handlereq(res)) {
					let obj = res.result || '';
					if (!obj) return;
					// 用于弹窗的字段  
					this.currentDetail_info = JSON.stringify(obj)
					// 字段信息 
					let parse_info = retJSONArr(obj.project_demand_info)
					// 用于编辑的字段
					this.editfieldlist = fn_retjson(parse_info);

					// 字段模板id
					if (obj.form_id) {
						this.currentMod_id = obj.form_id
					} else {
						if (parse_info.length) {
							parse_info.some((ele) => {
								if (ele.field == this.templaName) {
									this.currentMod_id = ele.content * 1;
									return;
								}
							})
						}
					}
					// 详情所有信息
					this.drawer_info = obj;
					this.isTableShow = true
					this.getmodulelist(this.c_projcet_div_id)
				}
				if (this.pageloading) {
					this.pageloading.close();
				}
			});
		},
		modify_pagesize(e) {
			let {
				val
			} = e;
			this.datapage.page = 1;
			this.datapage.pagesize = val;
			this.fn_tabledata();
		},
		switch_page(e) {
			let {
				val
			} = e;
			this.datapage.page = val;
			this.fn_tabledata();
		},
		// -----------------------------------
		setfilterArea() {
			this.filterpuplist = [{
				name: "创建人",
				list: this.memberlist,
				type: [{
					id: 0,
					name: "包含",
				},],
				select: true,

			},
			{
				name: "负责人",
				list: this.memberlist,
				type: [{
					id: 0,
					name: "包含",
				},],
				select: true,
			},
			{
				name: "协同人",
				list: this.memberlist,
				type: [{
					id: 0,
					name: "包含",
				},],
				select: true,
			},
			{
				isTime: true,
				name: "添加时间",
				list: "",
				type: [{
					id: 2,
					name: "等于",
				},
				{
					id: 3,
					name: "介于",
				},
				],
			},
			{
				isTime: true,
				name: "更新时间",
				list: "",
				type: [{
					id: 2,
					name: "等于",
				},
				{
					id: 3,
					name: "介于",
				},
				],
			},
			]
			for (let item of this.filterpuplist) {
				item.disabled = false
			}
		},

	},
	data() {
		return {
			surplus: 600,
			screVal1: [],
			screVal2: [],
			pageloading: '',

			typeslist: [
				{
					id: 3,
					name: '问题',
				},
			],  // 类型
			c_projcet_div_id: 4,

			billet_tit: '新建问题',
			templaName: '问题模板',

			edit_show: false, // 是否为编辑状态

			field_initial: [], //  未处理过的字段信息
			currentMod_id: '', //  模板列表
			currentModulList: [], //  当前模板 id
			projectCode: '', // "问题编号"
			Levellist: [], // 问题等级列表
			Statuslist: [], // 问题状态列表

			field_create: [], // 未保存的 字段合集
			savelist: [], // 保存时的 字段合集
			dailyRecord: [], // 编辑前的字段 ，用于判断是否修改过

			drawer_info: '', // 详情所有信息
			currentDetail_info: '', // 用于弹窗的字段
			editfieldlist: [], // 用于编辑的字段
			currentpup_id: '', // 当前详情id
			isTableShow: false,
			comtomerModuleTable: [],
			field_details: [],
			savenew: true,

			drawer_show: false, // 详情划窗是否显示
			drawer_loading: true, // 详情划窗是否加载完成

			// 1级大分类
			classlist: [
				{
					type: 1,
					name: '基础信息',
				},
				{
					type: 2,
					name: '问题信息',
				},
				{
					type: 3,
					name: '问题内容',
				},
			],
			// 新建弹窗
			createPup: false,
			// 是否为切换模板状态
			isSwitch: false,

			Referencearr: [{
				key: 'project_demand_code',
				name: '问题编号',
			},
			{
				key: 'title',
				name: '问题名称',
			},
			{
				key: 'content',
				name: '问题内容',
			},

			{
				key: 'project_demand_type',
				name: '问题类型',
			},
			{
				key: 'project_id',
				name: '问题项目',
			},
			{
				key: 'level',
				name: '问题级别',
			},
			{
				key: 'status',
				name: '问题状态',
			},
			{
				key: 'member_id',
				name: '负责人',
			},
			{
				key: 'form_id',
				name: '问题模板',
			},
			],
			ReferenceTime: [{
				key: 'start_time',
				name: '问题开始日期',
			},
			{
				key: 'plan_completion_time',
				name: '计划完成日期',
			},

			],

			// =============================================  
			// 合同源单 项目附件
			memberlist: [], // 成员列表
			table_loading: false,
			// 
			search_member: [], // 创建人，负责人
			assistantMember: [], // 协同人
			searchPhone: '', // 手机

			search_time: [], // 添加时间
			search_edit_time: [], // 更新时间
			// 
			class_type: 0, //	是	int	0:全部1


			search_name: '',
			sort_type: 1,

			search_member: [],
			// 筛选条件弹窗列表
			FilterList: [{
				lv1_selVal: null,
				lv2_selVal: null,
				lv3_selVal: null,
			},],
			defFilter: [{
				lv1_selVal: null,
				lv2_selVal: null,
				lv3_selVal: null,
			},],
			// 筛选项
			filterpuplist: [],

			// 当前视图配置
			localviewOperate: {},
			// 执行视图配置
			remoteviewOperate: {},


			// 
			// 列表
			datapage: {
				pagesize: 50,
				page: 1,
				total: 0,
				list: [],
			},
			check_list: [],
			customPageSize: 50,
			// 

			// 表头
			tableColumn: [{
				name: '问题名称',
				prop: 'title',
				width: 200,
			},
			{
				prop: 'project_demand_code',
				name: '问题编码',
				width: 200,
			},
			{
				prop: 'level_name',
				name: '问题级别',
			},
			{
				prop: 'status_name',
				name: '问题状态',
			},
			{
				prop: 'member_name',
				name: '负责人',
			},
			// {
			// 	prop: 'creator_name',
			// 	name: '创建人',
			// },
			{
				prop: 'start_time',
				name: '开始日期',
			},
			{
				prop: 'plan_completion_time',
				name: '计划完成日期',
			},


			],
			// 


		}
	},
}
</script>


<style lang="scss" scoped>
@import "@/assets/css/public.scss";
</style>